import { getUrl, Request } from "../../request";

export const getSliders = (
  city_id,
  category_id,
  mobile,
  location = "main_page"
) => {
  const query = {
    city_id,
    category_id,
    location,
  };
  if (mobile) {
    query["mobile"] = 1;
  } else {
    query["desktop"] = 1;
  }
  return Request.get(getUrl("/api/v1/content/slider/"), query);
};

export const getFaqs = () => {
  return Request.get(getUrl("/api/v1/content/faq"));
};
